export function aggregateAccountData(state: any) {
  const allAccounts = state.getAllAccounts();

  const accountsByType = (allAccounts || []).reduce((acc: Record<string, number>, account: any) => {
    const type = account?.type || 'unknown';
    acc[type] = (acc[type] || 0) + 1;
    return acc;
  }, {} as Record<string, number>);

  const accountsByInstitution = Array.from((state.connections || new Map()).entries() as any).map(
    ([institutionId, connection]: [string, any]) => {
      const name = connection?.connectionData?.institution_name || institutionId;
      const accountCount = connection?.accounts?.length || 0;
      const totalValue = (connection?.accounts || []).reduce((sum: number, acc: any) => {
        const balanceNum = typeof acc?.calculatedBalance === 'number'
          ? acc.calculatedBalance
          : parseFloat(acc?.balance?.toString?.() || '0');
        return sum + (isNaN(balanceNum) ? 0 : balanceNum);
      }, 0);
      return {
        institutionId,
        institutionName: name,
        accountCount,
        totalValue,
      };
    }
  );

  return {
    totalAccounts: allAccounts?.length || 0,
    totalValue: typeof state.getTotalAccountValue === 'function' ? state.getTotalAccountValue() : 0,
    accountsByType,
    accountsByInstitution,
  };
}
